export default "__VITE_ASSET__COyyRHcn__"